import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import LocationTileSkeletonGrid from './LocationTileSkeletonGrid';
import MapSkeleton from './MapSkeleton';

/**
 * Full-layout skeleton that mirrors LocationLayout's two-column flex
 * structure. When the map is visible, the card skeleton occupies the
 * left column and a map skeleton fills the right column — keeping the
 * layout stable and preventing the full-width → split-layout jump.
 */
const LocationLayoutSkeleton = ({ showMap = false, count = 8 }) => {
	const containerClassNames = setClassNames([
		'location-layout',
		'mx-auto',
		'py-4',
		'py-lg-5',
		'pl-4'
	]);

	const tilesClassNames = setClassNames([
		'flex-fill',
		'mb-4',
		'pr-0',
		showMap ? 'pr-6 pr-xl-8' : ''
	]);

	return (
		<div
			className={containerClassNames}
			data-testid="location-layout-skeleton"
			role="status"
			aria-label="Loading locations"
		>
			<div className="d-flex flex-column flex-lg-row w-100">
				<div className={tilesClassNames} style={{ minWidth: 0 }}>
					<div
						className="w-100 mx-auto p-0"
						style={{ maxWidth: '1200px' }}
					>
						<LocationTileSkeletonGrid count={count} />
					</div>
				</div>
				{showMap && <MapSkeleton />}
			</div>
		</div>
	);
};

LocationLayoutSkeleton.propTypes = {
	showMap: PropTypes.bool,
	count: PropTypes.number
};

export default LocationLayoutSkeleton;
